import { render, staticRenderFns } from "./CabinetHeader.vue?vue&type=template&id=5a2f6f90&scoped=true"
import script from "./CabinetHeader.vue?vue&type=script&lang=js"
export * from "./CabinetHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2f6f90",
  null
  
)

export default component.exports